{#if textOnly && iconOnly}
    <Button
        cssClass="prom-icon-button {iconPlacementClass} {iconClass}"
        {disabled}
        {haspopup}
        {expanded}
        {id}
        {large}
        {loading}
        {text}
        {type}
        {htmlType}
        {ariaLabel}
        {labelledby}
        {describedby}
        on:blur
        on:click
        on:focus
        on:keyup
        on:keydown
    >
    </Button>
{:else if textOnly}
    <Button
        cssClass="prom-icon-button {textOnlyClass}"
        {disabled}
        {haspopup}
        {expanded}
        {iconOnly}
        {id}
        {large}
        {loading}
        {text}
        {type}
        {htmlType}
        {ariaLabel}
        {labelledby}
        {describedby}
        on:blur
        on:click
        on:focus
        on:keyup
        on:keydown
    >
    </Button>
{:else}
    <Button
        cssClass="prom-icon-button {iconOnlyClass} {iconPlacementClass} {iconClass} {aiIconClass}"
        {disabled}
        {haspopup}
        {expanded}
        {iconOnly}
        {id}
        {large}
        {loading}
        {text}
        {type}
        {htmlType}
        {ariaLabel}
        {labelledby}
        {describedby}
        on:blur
        on:click
        on:focus
        on:keyup
        on:keydown
    >
    </Button>
{/if}

<script>
    import Button from '../../Button/v1/Button.svelte';

    /** @type {boolean} */
    export let disabled = false;
    /** @type {'false'|'true'|'menu'|'listbox'|'tree'|'grid'|'dialog'} */
    export let haspopup = undefined;
    /** @type {boolean} */
    export let expanded = undefined;
    /** @type {'submit'|'button'|'reset'} */
    export let htmlType = 'submit';
    /** @type {string} */
    export let iconClass = '';
    /** @type {boolean} */
    export let iconOnly = false;
    /** @type {'start'|'end'} */
    export let iconPlacement = 'start';
    /** @type {string} */
    export let id = undefined;
    /** @type {boolean} */
    export let large = false;
    /** @type {boolean} */
    export let loading = false;
    /** @type {string} */
    export let text = '';
    /** @type {boolean} */
    export let textOnly = false;
    /** @type {'basic'|'basic-negative'| 'primary'|'secondary'|'destructive'|'plain'|'ai'} */
    export let type = 'basic';
    /** @type {string | undefined} */
    export let ariaLabel = undefined;
    /** @type {string | undefined} */
    export let labelledby = undefined;
    /** @type {string} */
    export let describedby = undefined;

    $: {
        if (iconOnly && textOnly) {
            console.warn('The attributes iconOnly and textOnly cannot be both set to false.');
        }
    }

    $: {
        if (!iconPlacement || typeof iconPlacement !== 'string' || (iconPlacement !== 'start' && iconPlacement !== 'end')) {
            console.warn('Valid values for iconPlacement is "start" and "end".');
        }
    }

    $: iconOnlyClass = iconOnly ? 'prom-icon-button--icon-only' : '';
    $: textOnlyClass = textOnly ? 'prom-icon-button--text-only' : '';
    $: iconPlacementClass = iconPlacement === 'end' ? 'prom-icon-button--icon-end' : '';
    $: aiIconClass = type === 'ai' ? 'prom-button__ai-icon' : '';
    $: iconClass = type === 'ai' ? '' : iconClass;
    $: iconOnly = type === 'ai' ? false : iconOnly;
    $: loading = type === 'ai' ? false : loading;
    $: textOnly = type === 'ai' ? false : textOnly;

</script>
